import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { Tab, Tabs } from "@nextui-org/react";

// ---------------------- Props

interface BookingDetailsProps {
  parentRoute: string;
}

// ---------------------- Component

const BookingDetails = ({ parentRoute }: BookingDetailsProps) => {
  // --------- Variables / Hooks

  const { pathname } = useLocation();

  const { id } = useParams();

  const navigate = useNavigate();

  // --------- Helpers

  const getSelectedKey = () => {
    const path = pathname.split("/").pop();

    return path || "overview";
  };

  const handleTabChange = (key: string) => {
    navigate(`${parentRoute}/details/${id}/${key}`, { replace: true });
  };

  // --------- JSX

  return (
    <>
      <div className="flex h-full w-full flex-col">
        {/*******************************************/}
        {/* Tabs */}
        {/*******************************************/}

        <Tabs
          aria-label="Booking Details Tabs"
          variant="underlined"
          fullWidth
          classNames={{
            cursor: "bg-blue-500 dark:bg-blue-500 w-full",
            tab: "h-10 xs:h-12 sm:h-14 text-[0.8rem] xs:text-sm sm:text-base",
          }}
          selectedKey={getSelectedKey()}
          onSelectionChange={(key) => handleTabChange(key.toString())}
        >
          <Tab
            key="overview"
            title="Overview"
            className="w-[30%] xs:w-1/3"
          />
          <Tab
            key="instructions"
            title="Instructions"
            className="w-[30%] xs:w-1/3"
          />
          <Tab
            key="posts-notes"
            title="Posts/Notes"
            className="w-[30%] xs:w-1/3"
          />
        </Tabs>

        {/*******************************************/}
        {/* Tab Content */}
        {/*******************************************/}

        <div className="mt-4 flex-grow overflow-y-auto overflow-x-hidden rounded-lg bg-gray-100/30 p-4 dark:bg-gray-800/50">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default BookingDetails;
